const INSTALL_MARKER = '__preikaPublicRouteCompatibilityInstalled'

/**
 * 既存router/index.jsの認証ガードは、動的に追加される公開ルートを知らず、
 * 未ログイン時に/account-invitationをLoginへ転送してしまう。
 *
 * Vue Routerの初回解決前に既存ガードを1度だけ包み、meta.publicのルートだけを
 * 通過させる。保護ルートは従来の認証ガードとaccess-contextガードを通過する。
 */
export default function installLegacyPublicRouteCompatibility (router) {
  if (!router || router[INSTALL_MARKER]) return
  router[INSTALL_MARKER] = true

  if (!Array.isArray(router.beforeHooks) || !router.beforeHooks.length) return

  const legacyAuthenticationGuard = router.beforeHooks[0]
  router.beforeHooks[0] = (to, from, next) => {
    if (to && to.meta && to.meta.public === true) {
      next()
      return
    }
    legacyAuthenticationGuard(to, from, next)
  }
}
